import React from 'react';
import { fetchPageState } from '../utilities/fetch-api';

import VerifyEmailSentPage from './VerifyEmailSentPage';
import ReverifyEmailSentPage from './ReverifyEmailSentPage';
import { VerificationType } from '../types';
import { useAppSelector } from '../stores/redux.store';

export async function verifyEmailSentLoader({ request }: { request: Request }) {
  return await fetchPageState('/rest/verify-email/sent/state', request, {
    capabilities: ['capability-group--login', 'capability-name--mfa'],
  });
}

export const VerifyOrReverifyEmailSentPage = () => {
  const verificationType = useAppSelector(state => state.verifyEmailSent.verificationType);
  return verificationType === VerificationType.Verify ? (
    <VerifyEmailSentPage />
  ) : (
    <ReverifyEmailSentPage />
  );
};

export default VerifyOrReverifyEmailSentPage;
